export const cxMenu = {
    list: 'p-0 m-0',
    groupLabel: 'block px-4 py-2 bg-white font-bold txt-c3 border-b border-solid border-grey-lighter',
    item: 'flex justify-between items-center p-4 bg-grey-lightest border-b border-solid border-grey-lighter',
    itemLabel: 'flex-1 ellipsis',
    back: 'flex justify-between items-center p-4 text-center bg-white border-b border-solid border-grey-lighter',
    backLabel: 'flex-1 align-center'
};

export const menuItemMedia = {
    root: 'flex py-2 px-4 border-b border-solid border-grey-lighter',
    left: 'flex-0 w-24',
    right: 'flex-1 w-px pl-2',
    thumbnailWrap: 'img-ratio-4x3 border border-solid border-grey-lighter bg-white',
    thumbnail: 'lazyload fade-up block',
    title: 'leading-normal my-0 text-sm ellipsis',
    detail: 'my-0 text-sm'
};

export const nav = {
    primary: 'flex flex-col absolute h-full pin md:w-full md:max-w-sm ml-10 bg-grey-lightest text-base z-20'
};